import React, { useState } from 'react';
import { Upload, Button, message, Card } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { ragApi, DocumentUploadData } from '../services/ragApi';

const { Dragger } = Upload;

interface DocumentUploadProps {
  onUploadSuccess: (result: any) => void;
}

const DocumentUpload: React.FC<DocumentUploadProps> = ({ onUploadSuccess }) => {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);

  const handleUpload = async () => {
    if (!file) {
      message.error('請選擇一個文件');
      return;
    }

    setUploading(true);

    const uploadData: DocumentUploadData = {
      file,
    };

    try {
      const result = await ragApi.uploadDocument(uploadData);
      onUploadSuccess(result);
      setFile(null);
    } catch (error) {
      message.error('文件上傳失敗');
    } finally {
      setUploading(false);
    }
  };

  return (
    <Card title="文檔上傳">
      <Dragger
        name="file"
        multiple={false}
        beforeUpload={(file) => {
          setFile(file);
          return false; // Prevent auto-upload
        }}
        onRemove={() => setFile(null)}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">點擊或拖拽文件到此區域上傳</p>
        <p className="ant-upload-hint">支持單文件上傳。嚴禁上傳公司數據或其他敏感文件。</p>
      </Dragger>
      

      <Button
        type="primary"
        onClick={handleUpload}
        disabled={!file}
        loading={uploading}
        style={{ marginTop: 16 }}
      >
        {uploading ? '上傳中' : '開始上傳'}
      </Button>
    </Card>
  );
};

export default DocumentUpload;